<!-- Exchange -->
<ion-grid>
  <ion-row *ngIf="!!ballotObservable.value">

    <ion-col class="cards-group-selection ion-align-items-center ion-text-center" size="6">

      <div class="group-background" [ngClass]="{'group-background-visible': showBackground, 'gradient__primary-secondary-180': showBackground, 'group-background-animation': selectedValue==='left' && animateSelected }">
        <div (click)="select('left');" class="selection-indicator" [ngClass]="{'selected': selectedValue==='left', 'animate__animated animate__pulse': selectedValue==='left' && animateSelected}">
          <app-tb-player-card *ngFor="let player of ballotObservable.value.left_players" [player]="player" [ballot]="ballotObservable.value" [cardSize]="cardsSize"></app-tb-player-card>
        </div>
      </div>

      <div class="percentage-container ion-text-center" [ngClass]="{visible: !!votes}">
        <ion-badge *ngIf="!!votes" class="percentage-badge" color="tertiary">{{ votes.left }}%</ion-badge>
      </div>

    </ion-col>

    <ion-col class="cards-group-selection ion-align-items-center ion-text-center" size="6">

      <div class="group-background" [ngClass]="{'group-background-visible': showBackground, 'gradient__primary-secondary-180': showBackground, 'group-background-animation': selectedValue==='right' && animateSelected }">
        <div (click)="select('right')" class="selection-indicator" [ngClass]="{'selected': selectedValue==='right', 'animate__animated animate__pulse': selectedValue==='right' && animateSelected}">
          <app-tb-player-card *ngFor="let player of ballotObservable.value.right_players" [player]="player" [ballot]="ballotObservable.value" [cardSize]="cardsSize"></app-tb-player-card>
        </div>
      </div>

      <div class="percentage-container ion-text-center" [ngClass]="{visible: !!votes}">
        <ion-badge *ngIf="!!votes" class="percentage-badge" color="tertiary">{{ votes.right }}%</ion-badge>
      </div>

    </ion-col>

  </ion-row>
  <ion-row class="total-votes-container" [ngClass]="{visible: !!totalVotes || totalVotes === 0}">
    <ion-col class="ion-align-items-center ion-text-center" size="12">
      <ion-badge class="total-votes-badge" color="tertiary"> {{ totalVotes }} <br> <ion-text i18n>Voti</ion-text></ion-badge>
    </ion-col>
  </ion-row>
</ion-grid>
